<template>
  <layout name="LayoutDefault">
    <div class="Contact">
      <!-- Page Content -->
      <div class="container">
        <!-- Page Features -->
        <div class="pt-0 pt-md-3">
          <section class="section">
            <div class="section-contents text-justify blog-detail">
              <div class="row blog-row">
                <div class="col-md-8">

                  <div>
                    <div class="delivery-section mb-4">
                      <h4>এরিয়া সিলেক্ট করুন</h4>
                      <div class="delivery-options">
                        <div v-for="(type, index) in shippingTypes" 
                             :key="index"
                             class="delivery-option"
                             :class="{ 'active': order.shipping_rate_id === type.id }"
                             @click="selectShippingType(type.id, type.inside_price)">
                          <div class="d-flex align-items-center">
                            <div class="radio-dot">
                              <i class="fa fa-check" v-if="order.shipping_rate_id == type.id"></i>
                            </div>
                            <div class="flex-grow-1">
                              <h5>{{ type.title }}</h5>
                              <small>ডেলিভারি চার্জ {{ type.inside_price }}</small>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="payment-section">
                      <h4>পে করুন</h4>
                      <div class="payment-options">
                        <div class="payment-option"
                             :class="{ 'active': order.payment_type === 'COD' }"
                             @click="selectPaymentType('COD')">
                          <div class="d-flex align-items-center">
                            <div class="radio-dot">
                              <i class="fa fa-check" v-if="order.payment_type === 'COD'"></i>
                            </div>
                            <div class="flex-grow-1">
                              <h5>Cash On Delivery</h5>
                              <small>পেমেন্ট ফ্রি 0% - Tk. {{ grandTotal }}</small>
                            </div>
                            <div class="payment-icon">
                              <img src="/assets/img/cod.png" alt="ssl" height="40">
                            </div>
                          </div>
                        </div>

                        <div class="payment-option"
                             :class="{ 'active': order.payment_type === 'SSL' }"
                             @click="selectPaymentType('SSL')">
                          <div class="d-flex align-items-center">
                            <div class="radio-dot">
                              <i class="fa fa-check" v-if="order.payment_type === 'SSL'"></i>
                            </div>
                            <div class="flex-grow-1">
                              <h5>Online Payment</h5>
                              <small>পেমেন্ট ফ্রি 0% - Tk. {{ grandTotal }}</small>
                            </div>
                            <div class="payment-icon">
                              <img src="/assets/img/ssl.png" alt="ssl" height="35">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
             
                  <!-- <div id="accordion" class="delivery-address">
                    <div class="card">
                      <div class="card-header py-4" id="headingOne">
                        <h5
                          class="mb-0 collapsed d-flex justify-content-between"
                        >
                          <div class="text-left">
                            <i class="fa fa-map-marker pr-1"></i> ডেলিভারি
                            ঠিকানা
                          </div>
                          <div class="flex-last-address">
                            <span class="last-address" v-if="selectedAddress"
                              >{{ selectedAddress.address_1 }},
                              {{ selectedAddress.region.name }},
                              {{ selectedAddress.city.name }},
                              {{ selectedAddress.area.name }}</span
                            >
                            <span class="last-address" v-else
                              >আপনার কোনো ডেলিভারি ঠিকানা সিলেক্ট করা নাই</span
                            >
                          </div>
                          <div
                            data-toggle="collapse"
                            data-target="#collapseOne"
                            aria-expanded="false"
                            aria-controls="collapseOne"
                          >
                            <div
                              class="btn btn-outline-success btn-xs text-right"
                            >
                              <span v-if="notFound">অ্যাড করুন</span>
                              <span v-else>পরিবর্তন করুন</span>
                            </div>
                          </div>
                        </h5>
                      </div>

                      <div
                        id="collapseOne"
                        class="collapse"
                        aria-labelledby="headingOne"
                        data-parent="#accordion"
                      >
                        <div class="card-body">
                          <div
                            v-for="(row, key) in addresses"
                            v-bind:key="key"
                            class="btn btn-outline-secondary btn-block"
                          >
                            <label
                              class="pull-left mr-1"
                              @click.prevent="selectDeliveryAddress(row)"
                              style="max-width: 85%;text-align: left;"
                            >
                              <input type="radio" name="delivery_address" :checked="selectedAddress === row" />
                              {{ row.address_1 }}, {{ row.region.name }},
                              {{ row.city.name }},
                              {{ row.area.name }}
                            </label>
                            <span class="pull-right text-right">
                              <span
                                @click="edit(row)"
                                class="ml-3 btn btn-outline-info btn-xs"
                                >Edit</span
                              >
                            </span>
                          </div>

                          <button
                            class="btn btn-outline-success btn-block"
                            @click="addDeliveryAddress"
                          >
                            <i class="fa fa-plus"></i> নতুন ঠিকানা যোগ করুন
                          </button>
                        </div>
                      </div>
                    </div>
                  </div> -->
      

           

                </div>

                <div class="col-md-4 checkout-cart-details mt-4 mt-md-0">
                  <div class="fixed-checkout card">
                    <section id="checkout-sidebar" class="check-sidebar p-3">
                      <div class="checkout-sidebar__header">
                        <h1>চেকআউট সামারি</h1>
                      </div>

                      <div class="d-flex justify-content-between summary-row">
                        <div>সাব টোটাল</div>
                        <div>Tk. {{ amount }}</div>
                      </div>

                      <div class="d-flex justify-content-between summary-row">
                        <div>ডেলিভারি চার্জ</div>
                        <div>Tk. {{ deliveryCharge }}</div>
                      </div>
                      <div class="d-flex justify-content-between summary-row">
                        <div>ডিসকাউন্ট</div>
                        <div>Tk. {{ discount }}</div>
                      </div>
                      <!-- <div class="d-flex justify-content-between summary-row">
                        <div>টোটাল</div>
                        <div>Tk. {{ amount }}</div>
                      </div>                       -->
                      
                      <div class="d-flex justify-content-between summary-row" v-if="giftPrice > 0">
                        <div>মোড়ানো</div>
                        <div>Tk. {{ giftPrice }}</div>
                      </div>

                      <div
                        class="d-flex justify-content-between summary-row border-bottom-0 mb-4"
                      >
                        <div>গ্রান্ড টোটাল</div>
                        <div>Tk. {{ grandTotal }}</div>
                      </div>
                    </section>
                  </div>

                  <div class="row">
                    <!-- <div class="col-lg-12 my-3">
                      <div class=" payment-type text-right">
                        <span class="mr-3 font-weight-bold">পেমেন্ট টাইপ</span>
                        <label class="mr-2"><input type="radio" name="payment_type" v-model="payment_type" value="COD" checked> ক্যাশ অন ডেলিভারি</label> 
                        <label>  <input type="radio" name="payment_type" v-model="payment_type" value="SSL"> পে উইথ bKash/Visa/Master Card</label>
                      </div>
                    </div> -->
                    <!-- <div class="col-lg-12 mb-3">
                      <div class=" payment-type text-right">
                        <span class="mr-3 font-weight-bold">ডেলিভারি টাইপ</span>
                        <label class="mr-2">
                          <input @change="calculateShippingCost($event)" type="radio" name="shipping_type" v-model="shipping_type" value="REGULAR"> নরমাল ডেলিভারি
                        </label> 
                        <label v-if="selectedAddress && selectedAddress.city.name === 'Dhaka'">  
                          <input @change="calculateShippingCost($event)" type="radio" name="shipping_type" v-model="shipping_type" value="EXPRESS"> এক্সপ্রেস ডেলিভারি
                        </label> 
                      </div>
                    </div> -->
                    <div class="col-lg-12 ">
                      <div
                        class="btn-group mt-2 mb-1 w-100"
                        role="group"
                        aria-label="Basic example"
                      >
                        <button
                          type="button"
                          class="btn btn-primary w-100"
                          :disabled="submitted"
                          @click="placeOrder"
                        >
                          অর্ডার টি প্লেস করুন
                        </button>
                        <!-- <button type="button" class="btn btn-warning w-50">
                          <span class="currency">Tk.</span> {{ grandTotal }}
                        </button> -->
                      </div>
                    </div>
                  </div>
                  <p class="text-right">
                    আপনি কথাপ্রকাশের শর্তাদি এবং শর্তাবলীর সাথে একমত
                    <router-link :to="{ name: 'Terms' }"
                      >Terms & Conditions</router-link
                    >
                  </p>
                </div>
              </div>
            </div>
          </section>

          <!-- <div class="modal" id="addDelivery" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                <form method="post" @submit="addShippingAddress">
                  <div class="modal-header">
                    <h5 class="modal-title">নতুন ঠিকানা যোগ করুন</h5>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body ">
                    <div class="row">
                      <div class="form-group col-lg-6">
                        <label>নাম<span class="required">&nbsp;*</span></label>
                        <input
                          type="text"
                          ref="first_name"
                          v-model="formData.first_name"
                          class="form-control"
                          placeholder="নাম"
                          autocomplete="off"
                        />
                      </div>

                      <div class="form-group col-lg-6">
                        <label
                          >মোবাইল নাম্বার<span class="required"
                            >&nbsp;*</span
                          ></label
                        >
                        <div class="input-group mb-2">
                          <div class="input-group-prepend">
                            <span class="input-group-text">+88</span>
                          </div>
                          <input
                            type="text"
                            ref="phone"
                            v-model="formData.phone"
                            class="form-control"
                            placeholder="মোবাইল নাম্বার"
                            autocomplete="off"
                          />
                        </div>
                      </div>

                      <div class="form-group col-lg-12">
                        <label
                          >ঠিকানা<span class="required">&nbsp;*</span></label
                        >
                        <input
                          type="text"
                          ref="address_1"
                          v-model="formData.address_1"
                          class="form-control"
                          placeholder="ঠিকানা"
                          autocomplete="off"
                        />
                      </div>

                      <div class="form-group col-lg-6">
                        <label
                          >অঞ্চল<span class="required">&nbsp;*</span></label
                        >
                        <select
                          ref="region_id"
                          v-model="formData.region_id"
                          class="form-control"
                          autocomplete="off"
                          @change="regionChanged"
                        >
                          <option value="">অঞ্চল</option>
                          <option
                            v-for="(row, key) in region"
                            v-bind:key="key"
                            :value="`${row.id}`"
                            >{{ row.name }}</option
                          >
                        </select>
                      </div>

                      <div class="form-group col-lg-6">
                        <label>সিটি<span class="required">&nbsp;*</span></label>
                        <select
                          ref="city_id"
                          v-model="formData.city_id"
                          class="form-control"
                          @change="getArea"
                        >
                          <option value="">সিটি</option>
                          <option
                            v-for="(row, key) in city"
                            v-bind:key="key"
                            :value="`${row.id}`"
                            >{{ row.name }}</option
                          >
                        </select>
                      </div>

                      <div class="form-group col-lg-12">
                        <label
                          >এরিয়া<span class="required">&nbsp;*</span></label
                        >
                        <select
                          ref="area_id"
                          v-model="formData.area_id"
                          class="form-control"
                        >
                          <option value="">এরিয়া</option>
                          <option
                            v-for="(row, key) in area"
                            v-bind:key="key"
                            :value="`${row.id}`"
                            >{{ row.name }}</option
                          >
                        </select>
                      </div>

                    </div>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      data-dismiss="modal"
                    >
                      বন্ধ করুন
                    </button>
                    <button type="submit" class="btn btn-primary">
                      যোগ করুন
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div> -->
        </div>
      </div>
      <!-- /.container -->
    </div>
  </layout>
</template>

<script>
import Layout from "../layouts/Layout";

export default {
  name: `Checkout`,
  components: {
    Layout
  },
  data() {
    return {
      notFound: false,
      submitted: false,
      addresses: null,
      selectedAddress: null,
      errors: [],
      cart: [],
      region: [],
      city: [],
      area: [],
      shippingTypes: [],
      formData: {
        region_id: "",
        city_id: "",
        area_id: ""
      },
      amount: this.$helper.cartAmount(),
      grandTotal: 0.0,
      discount: localStorage.getItem("discount"),
      deliveryCharge: localStorage.getItem("deliveryCharge") || 0.00,
      gift: localStorage.getItem("gift"),
      giftPrice: localStorage.getItem("giftPrice"),
      couponDisabled: 0,
      redirectUrl: "",
      order: {
        customer_id: localStorage.getItem("customer_id"),
        shipping_type: "REGULAR",
        shipping_rate_id: null,
        payment_type: 'COD'
      },
      customerInfo: JSON.parse(localStorage.getItem("customerInfo") || "{}")
    };
  },
  mounted() {
    // Check if customer info is complete
    if (!this.customerInfo.mobile || !this.customerInfo.name) {
      this.flashMessage.error({ 
        message: "দয়া করে প্রথমে আপনার নাম এবং ফোন নম্বর দিন",
        time: 3000,
        blockClass: 'error-message'
      });
      location.href = "cart";
      return;
    }

    this.cart = JSON.parse(localStorage.getItem("cart"));
    if (localStorage.getItem("token")) this.couponDisabled = 1;
    this.calculateGrandTotal();
    this.fetchShippingTypes();
  },
  methods: {
    calculateGrandTotal() {
      this.grandTotal =
        parseFloat(this.amount) +
        parseFloat(this.deliveryCharge) +
        parseFloat(this.giftPrice) -
        parseFloat(this.discount);
      this.grandTotal = Math.ceil(this.grandTotal).toFixed(2);
    },
    // selectDeliveryAddress(row) {
    //   this.selectedAddress = row;
    //   this.calculateShippingCost();
    // },
    // addDeliveryAddress() {
    //   this.formData = {
    //     region_id: "",
    //     city_id: "",
    //     area_id: ""
    //   };
    //   $("#addDelivery").modal("show");
    // },
    // getRegion() {
    //   this.$authHttp
    //     .get("region")
    //     .then(response => {
    //       //   console.log(response.data);
    //       if (response.data.status) {
    //         this.region = response.data.region;
    //       }
    //     })
    //     .catch(e => {
    //       //  console.log(e);
    //     });
    // },
    // regionChanged(){
    //   this.formData.city_id = '';
    //   this.formData.area_id = '';
    //   this.city = '';
    //   this.area = '';
    //   this.getCity();
    // },
    // getCity() {
    //   this.$authHttp
    //     .get("city/" + this.formData.region_id)
    //     .then(response => {
    //       if (response.data.status) {
    //         this.city = response.data.city;
    //       }
    //     })
    //     .catch(e => {
    //       //   console.log(e);
    //     });
    // },
    // getArea() {
    //   this.$authHttp
    //     .get("area/" + this.formData.city_id)
    //     .then(response => {
    //       if (response.data.status) {
    //         this.area = response.data.area;
    //       }
    //     })
    //     .catch(e => {
    //       //  console.log(e);
    //     });
    // },
    // getLastDeliveryAddress() {
    //   this.$authHttp
    //     .get("customer-order-address")
    //     .then(response => {
    //       if (response.data.data.id) {
    //         this.selectedAddress = response.data.data;
    //         if(this.selectedAddress) this.calculateShippingCost();
    //       }
    //     })
    //     .catch(e => {
    //       console.log(e);
    //     });
    // },
    placeOrder() {
      if (!this.order.shipping_rate_id) {
        this.flashMessage.error({message: "ডেলিভারি এরিয়া সিলেক্ট করুন"});
        return false;
      }
      if (!this.order.payment_type) {
        this.flashMessage.error({message: "পেমেন্ট টাইপ সিলেক্ট করুন"});
        return false;
      }

      this.order.cart = JSON.parse(localStorage.getItem("cart"));
      this.order.shipping_cost = this.deliveryCharge;
      this.order.service_charge = this.giftPrice;
      this.order.discount_amount = this.discount;
      this.order.customer_mobile = this.customerInfo.mobile;
      this.order.customer_name = this.customerInfo.name;
      this.order.customer_address = this.customerInfo.address;

      this.submitted = true;

      // console.log('this.order==========>', this.order);
      // return;
      this.$http
        .post("order", this.order)
        .then(response => {
          if (response.data.order_id && this.order.payment_type == 'COD') {
            localStorage.setItem("cart", "");
            //location.href = "customer/dashboard/order/" + response.data.order_id;
            location.href = "success";
          } else if (response.data.order_id && this.order.payment_type == 'SSL') {
              let redirect_to = process.env.VUE_APP_BASEURL;
              let orderId = response.data.order_id;
              location.href = process.env.VUE_APP_DOMAIN+'pay-now/'+orderId+'?redirect_to='+redirect_to;
          }else{
            this.submitted = false;
            this.flashMessage.error({ message: "একটি ত্রুটি ঘটেছে, পরে আবার চেষ্টা করুন" });
            return false;
          }
        })
        .catch(e => {
          // console.log(e);
        });
    },
    // addShippingAddress: function(e) {
    //   e.preventDefault();
    //   if (!this.formData.first_name) {
    //     this.$refs.first_name.focus();
    //     this.flashMessage.error({ message: "নাম দিতে হবে" });
    //     return false;
    //   }
    //   if (!this.formData.phone) {
    //     this.$refs.phone.focus();
    //     this.flashMessage.error({ message: "মোবাইল নাম্বার দিতে হবে" });
    //     return false;
    //   }
    //   if (!this.formData.address_1) {
    //     this.$refs.address_1.focus();
    //     this.flashMessage.error({ message: "ঠিকানা দিতে হবে" });
    //     return false;
    //   }
    //   if (!this.formData.region_id) {
    //     this.$refs.region_id.focus();
    //     this.flashMessage.error({ message: "অঞ্চল দিতে হবে" });
    //     return false;
    //   }
    //   if (!this.formData.city_id) {
    //     this.$refs.city_id.focus();
    //     this.flashMessage.error({ message: "সিটি দিতে হবে" });
    //     return false;
    //   }
    //   if (!this.formData.area_id) {
    //     this.$refs.area_id.focus();
    //     this.flashMessage.error({ message: "এরিয়া দিতে হবে" });
    //     return false;
    //   }
    //   if (this.formData.id) {
    //     this.updateShipping(this.formData);
    //   } else {
    //     this.storeShipping(this.formData);
    //   }
    // },
    // storeShipping(formData) {
    //   this.$authHttp
    //     .post("customer-shipping-address", formData)
    //     .then(response => {
    //       if (response.data.status) {
    //         this.flashMessage.success({
    //           message: "Address created successfully."
    //         });
    //         this.getShippingAddress();
    //         $("#addDelivery").modal("hide");
    //         this.formData = { first_name: "" };
    //       } else {
    //         this.flashMessage.error({
    //           message: response.data.message
    //         });
    //       }
    //     })
    //     .catch(e => {
    //       //console.log(e);
    //     });
    // },
    // edit(row) {
    //   this.formData = row;
    //   this.getCity();
    //   this.getArea();
    //   $("#addDelivery").modal("show");
    // },
    // updateShipping(formData) {
    //   this.$authHttp
    //     .put("customer-shipping-address/" + formData.id, formData)
    //     .then(response => {
    //       this.flashMessage.success({
    //         message: "Address updated successfully."
    //       });
    //       this.getShippingAddress();
    //       $("#addDelivery").modal("hide");
    //     })
    //     .catch(e => {
    //       //   console.log(e);
    //     });
    // },
    // getShippingAddress() {
    //   this.$authHttp
    //     .get("getShippingAddress")
    //     .then(response => {
    //       this.addresses = response.data;
    //       if (this.addresses.length < 1) this.notFound = true;
    //     })
    //     .catch(e => {
    //       // console.log(e);
    //       this.notFound = true;
    //     });
    // },
    // calculateShippingCost() {
    //   this.cart = JSON.parse(localStorage.getItem("cart"));
    //   const data = {
    //     cart: this.cart,
    //     region_id: this.selectedAddress.region.id,
    //     city_id: this.selectedAddress.city.id,
    //     area_id: this.selectedAddress.area.id,
    //     shipping_type: this.shipping_type,
    //   };

    //   this.$authHttp
    //     .post("calculate-shipping-cost", data)
    //     .then(response => {
    //       this.deliveryCharge = response.data.deliveryCharge;
    //       localStorage.setItem("deliveryCharge", response.data.deliveryCharge);
    //       this.calculateGrandTotal();
    //     })
    //     .catch(e => {
    //       //  console.log(e);
    //     });
    // },
    fetchShippingTypes() {
      this.$http
        .get("get-shipping-types")
        .then(response => {
          if (response.data && response.data.status) {
            this.shippingTypes = response.data.shippingTypes || [];
            if (this.shippingTypes && this.shippingTypes.length > 0) {
              this.shipping_rate_id = this.shippingTypes[0].id;
              this.deliveryCharge = this.shippingTypes[0].inside_price;
              this.order.shipping_rate_id = this.shippingTypes[0].id;
              localStorage.setItem("deliveryCharge", this.deliveryCharge);
            }
          } else {
            console.error("Invalid response format:", response.data);
            this.shippingTypes = [];
          }
        })
        .catch(e => {
          console.error("Error fetching shipping types:", e);
          this.shippingTypes = [];
        });
    },
    selectShippingType(id, price) {
      this.order.shipping_rate_id = id;
      this.deliveryCharge = price;
      localStorage.setItem("deliveryCharge", price);
      // alert(this.order.shipping_rate_id)
      this.calculateGrandTotal();
    },
    selectPaymentType(type) {
      this.order.payment_type = type;
    }
  },
  watch: {
    $route(to, from) {
      this.show = false;
    }
  }
};
</script>




